var map = {
	"./kabutocho-dark.svg": 1126,
	"./kabutocho-light.svg": 1127,
	"./long-dark-colored.svg": 1657,
	"./long-dark-monochrome-outline.svg": 1658,
	"./long-dark-monochrome-transparent.svg": 1659,
	"./long-dark-monochrome.svg": 1660,
	"./long-light-colored-transparent.svg": 1661,
	"./long-light-colored.svg": 1662,
	"./long-light-monchrome.svg": 1663,
	"./long-light-monochrome-outline.svg": 1664,
	"./long-light-monochrome-transparent.svg": 1665,
	"./short-dark-logo.svg": 851,
	"./short-light-logo.svg": 852,
	"./square-dark-colored.svg": 1666,
	"./square-dark-monochrome-outline.svg": 1667,
	"./square-dark-monochrome-transparent.svg": 1668,
	"./square-dark-monochrome.svg": 1669,
	"./square-light-colored-transparent.svg": 1670,
	"./square-light-colored.svg": 850,
	"./square-light-monochrome-outline.svg": 1671,
	"./square-light-monochrome-transparent.svg": 1672,
	"./square-light-monochrome.svg": 1673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1656;